export const RestrictedRegionEvent = {
  RestrictedLocationPopupView: 'restricted_location_popup__view',
  RestrictedLocationPopupClickVisiting: 'restricted_location_popup__click_visiting',
  RestrictedLocationPopupClickGotIt: 'restricted_location_popup__click_got_it',
  SelectNationalityPageClickContinue: 'select_nationality_page__click_continue',
} as const;

export interface RestrictedRegionEventDataType {
  select_nationality_page__click_continue: {
    country: string;
  };
}
